import React, { useCallback, useEffect, useRef, useMemo, useState } from 'react';
import { isMobile } from 'react-device-detect';

import './index.scss';
import AntAuth from '../../utils/AntAuth';
import { AntGlobalContext } from '../../utils/AntContext';
import AntCondition from '../../utils/AntCondition';
import AntLocalization from '../../utils/AntLocalization';
import AntMainArea from './AntMainArea';
import AntPOSArea from './AntPOSArea';
import AntAuthArea from './AntAuthArea';
import { getScreenSizeClass } from '../../utils/screen';

import { GoogleOAuthProvider } from '@react-oauth/google';

export default function App(props) {
    const setCssVariableByTheme = useCallback(() => {
        var themeName = props.appInfo.theme;
        var isLocal = props.appInfo.isLocal;

        var AnteAppColor;
        var AnteNavigationColor;
        var AnteNavigationSelectedItemColor;
        var AnteNavigationLineColor;
        var AnteRowAltColor1;
        var AnteRowSelectedColor1;
        var AnteGroupBarSelectedColor1;
        var AnteBaseColor1;
        var AnteBaseColor2;
        var AnteTitleColor;
        var AnteLabelColor;
        var AnteButtonColor;
        var AnteButtonFocusedColor;
        var AnteLightBorderColor1;
        var AnteMediumBorderColor1;
        var AnteHoverColor1;
        var AnteBaseBGColor1;
        var AnteLinkColor1;
        var AnteFieldBorderColor;
        var AnteSeparatorColor;
        var AnteTagColor;
        var AnteMediumBackgroundColor;
        var AnteDarkBackgroundColor;
        var AnteDarkTitleColor;
        var AnteLoadingColor;

        AnteAppColor = '#1d489a';

        if (themeName === 'Ante-Yellow-Easybiz') {
            AnteNavigationColor = '#302f2c';
            AnteNavigationSelectedItemColor = '#efbf2c';
            AnteNavigationLineColor = '#353228';
            AnteLoadingColor = '#efbf2c';
            AnteRowAltColor1 = '#fcf5e9b0';
            AnteRowSelectedColor1 = '#b58e09';
            AnteGroupBarSelectedColor1 = '#d9a41a61';
            AnteBaseColor1 = '#855f1e';
            AnteBaseColor2 = '#99773b';
            AnteTitleColor = '#645c43';
            AnteLabelColor = '#2e2a1b';
            AnteButtonColor = '#e4d6bccc';
            AnteButtonFocusedColor = '#bead8ccc';
            AnteLightBorderColor1 = '#fcf5e9b0';
            AnteMediumBorderColor1 = '#af9e6240';
            AnteHoverColor1 = '#fbebb7';
            AnteBaseBGColor1 = '#f0ede7';
            AnteLinkColor1 = '#5a2a06';
            AnteFieldBorderColor = '#c9c7d3';
            AnteSeparatorColor = '#627aaf1f';
            AnteTagColor = '#d6bfa7';
            AnteMediumBackgroundColor = '#ede6dd';
            AnteDarkBackgroundColor = '#e2d9ceb0';
            AnteDarkTitleColor = '#884e2e';
        } else {
            AnteNavigationColor = '#1d489a'; // '#294b8a'; // '#2a3a79ed';
            AnteNavigationSelectedItemColor = '#fb8686d9';
            AnteNavigationLineColor = '#39498ae8';
            AnteLoadingColor = '#fb8686d9';
            AnteRowAltColor1 = '#e4eeff87';
            AnteRowSelectedColor1 = '#6d88c6d2';
            // AnteGroupBarSelectedColor1 = '#715cb736';
            // AnteGroupBarSelectedColor1 = '#715cb752';
            // AnteGroupBarSelectedColor1 = '#b27ccb52';
            AnteGroupBarSelectedColor1 = '#662a74c2';
            AnteBaseColor1 = '#6e97f6';
            AnteBaseColor2 = '#7288e1';
            AnteTitleColor = '#5475c2'; // '#5475c2';
            // AnteLabelColor = '#0c39a1'; //'#2d54ae'; // '#1a3b8df2';
            AnteLabelColor = '#2d54ae'; // '#1a3b8df2';
            AnteButtonColor = '#c9d6f8cc';
            AnteButtonFocusedColor = '#3378b5';
            AnteLightBorderColor1 = '#e4eeff87';
            AnteMediumBorderColor1 = '#627aaf40';
            AnteHoverColor1 = '#ebe6fcbd';
            AnteBaseBGColor1 = '#e7f0fd'; // '#e6effb'; // '#e6effb';

            AnteLinkColor1 = '#105ea4';
            AnteFieldBorderColor = '#627aaf40';
            AnteSeparatorColor = '#627aaf1f';
            AnteTagColor = '#bfcce6';
            AnteMediumBackgroundColor = '#dce2f39e';
            AnteDarkBackgroundColor = '#cee1fb';
            AnteDarkTitleColor = '#3e7ed9';
        }
        // if (isLocal) AnteAppColor = '#662a74';

        document.documentElement.style.setProperty('--AnteAppColor', AnteAppColor);

        document.documentElement.style.setProperty('--AnteNavigationColor', AnteNavigationColor);
        document.documentElement.style.setProperty('--AnteNavigationSelectedItemColor', AnteNavigationSelectedItemColor);
        document.documentElement.style.setProperty('--AnteNavigationLineColor', AnteNavigationLineColor);
        document.documentElement.style.setProperty('--AnteLoadingColor', AnteLoadingColor);
        document.documentElement.style.setProperty('--AnteRowAltColor1', AnteRowAltColor1);
        document.documentElement.style.setProperty('--AnteRowSelectedColor1', AnteRowSelectedColor1);
        document.documentElement.style.setProperty('--AnteGroupBarSelectedColor1', AnteGroupBarSelectedColor1);

        document.documentElement.style.setProperty('--AnteBaseColor1', AnteBaseColor1);
        document.documentElement.style.setProperty('--AnteBaseColor2', AnteBaseColor2);
        document.documentElement.style.setProperty('--AnteTitleColor', AnteTitleColor);
        document.documentElement.style.setProperty('--AnteLabelColor', AnteLabelColor);
        document.documentElement.style.setProperty('--AnteButtonColor', AnteButtonColor);
        document.documentElement.style.setProperty('--AnteButtonFocusedColor', AnteButtonFocusedColor);
        document.documentElement.style.setProperty('--AnteLightBorderColor1', AnteLightBorderColor1);
        document.documentElement.style.setProperty('--AnteMediumBorderColor1', AnteMediumBorderColor1);
        document.documentElement.style.setProperty('--AnteHoverColor1', AnteHoverColor1);
        document.documentElement.style.setProperty('--AnteBaseBGColor1', AnteBaseBGColor1);
        document.documentElement.style.setProperty('--AnteLinkColor1', AnteLinkColor1);
        document.documentElement.style.setProperty('--AnteFieldBorderColor', AnteFieldBorderColor);
        document.documentElement.style.setProperty('--AnteSeparatorColor', AnteSeparatorColor);
        document.documentElement.style.setProperty('--AnteTagColor', AnteTagColor);
        document.documentElement.style.setProperty('--AnteMediumBackgroundColor', AnteMediumBackgroundColor);
        document.documentElement.style.setProperty('--AnteDarkBackgroundColor', AnteDarkBackgroundColor);
        document.documentElement.style.setProperty('--AnteDarkTitleColor', AnteDarkTitleColor);

        // Design token mới (không đổi theo theme) — xem docs/superpowers/design-refs/DesignTokenStandard/reference.md
        document.documentElement.style.setProperty('--AnteTextMutedColor', '#627aafb3');

        document.documentElement.style.setProperty('--AnteSpacing1', '2px');
        document.documentElement.style.setProperty('--AnteSpacing2', '4px');
        document.documentElement.style.setProperty('--AnteSpacing3', '6px');
        document.documentElement.style.setProperty('--AnteSpacing4', '8px');
        document.documentElement.style.setProperty('--AnteSpacing5', '10px');
        document.documentElement.style.setProperty('--AnteSpacing6', '12px');
        document.documentElement.style.setProperty('--AnteSpacing7', '14px');
        document.documentElement.style.setProperty('--AnteSpacing8', '16px');
        document.documentElement.style.setProperty('--AnteSpacing9', '20px');
        document.documentElement.style.setProperty('--AnteSpacing10', '24px');

        document.documentElement.style.setProperty('--AnteFontSize1', '11px');
        document.documentElement.style.setProperty('--AnteFontSize2', '12px');
        document.documentElement.style.setProperty('--AnteFontSize3', '13px');
        document.documentElement.style.setProperty('--AnteFontSize4', '14px');
        document.documentElement.style.setProperty('--AnteFontSize5', '16px');
        document.documentElement.style.setProperty('--AnteFontSize6', '18px');
        document.documentElement.style.setProperty('--AnteFontSize7', '20px');
        document.documentElement.style.setProperty('--AnteFontSize8', '24px');

        document.documentElement.style.setProperty('--AnteFontFamily', '"Be Vietnam Pro", "Segoe UI", "Roboto", -apple-system, sans-serif');
        document.documentElement.style.setProperty('--AnteFontFamilyMono', 'ui-monospace, SFMono-Regular, Menlo, Consolas, monospace');

        document.documentElement.style.setProperty('--AnteRadius1', '2px');
        document.documentElement.style.setProperty('--AnteRadius2', '4px');
        document.documentElement.style.setProperty('--AnteRadius3', '6px');
        document.documentElement.style.setProperty('--AnteRadius4', '8px');
        document.documentElement.style.setProperty('--AnteRadius5', '12px');
        document.documentElement.style.setProperty('--AnteRadiusPill', '9999px');
    }, []);

    // Không gian Kế toán dùng thực đơn riêng (accountingNavigation/accountingModules); tính một lần khi mount như showMode,
    // đổi chế độ luôn tải lại trang. ante-web chưa truyền thực đơn kế toán thì giữ thực đơn Vận hành.
    const workspaceMode = useMemo(() => AntAuth.getWorkspaceMode(), []);
    const useAccountingNavigation =
        workspaceMode === 'Accounting' && props.accountingNavigation instanceof Array && props.accountingNavigation.length > 0;

    const appGlobal = {
        appNavigation: useAccountingNavigation ? props.accountingNavigation : props.appNavigation,
        appModules: useAccountingNavigation && props.accountingModules ? props.accountingModules : props.appModules,
        accountingNavigation: props.accountingNavigation,
        accountingQuickCreate: props.accountingQuickCreate,
        accountingQuickCreateGroups: props.accountingQuickCreateGroups,
        workspaceMode: useAccountingNavigation ? 'Accounting' : 'Operation',
        appInfo: props.appInfo,
        appRoutes: props.appRoutes,
        appAssets: props.appAssets,
        appConfig: props.appConfig,
        posNavigation: props.posNavigation,
        posRoutes: props.posRoutes,
        backgroundPrinters: props.backgroundPrinters,
        tableConfigs: []
    };

    const [loggedIn, setLoggedIn] = useState(AntAuth.isValidSession());
    // const [screenSizeClass, setScreenSizeClass] = useState(getScreenSizeClass());

    const init = useCallback(() => {
        AntLocalization.initLanguage();
        setCssVariableByTheme();
    }, []);

    // AntLocalization.initLanguage();

    const getShowMode = useCallback(() => AntAuth.getViewMode(), []);

    const showMode = useMemo(() => getShowMode(), []);

    useEffect(() => {
        init();
        setLoggedIn(AntAuth.isValidSession());
    }, []);

    // const logoutTimeout = useRef(null);
    // useEffect(() => {
    //     if (logoutTimeout.current) clearTimeout(logoutTimeout.current);
    //     logoutTimeout.current = setTimeout(
    //         (_loggedIn) => {
    //             // setScreenSizeClass(getScreenSizeClass());
    //             let logedIn = AntAuth.isValidSession();
    //             if (logedIn !== _loggedIn && !logedIn) AntAuth.logOut();
    //         },
    //         10000,
    //         loggedIn
    //     );
    // }, [loggedIn]);

    if (isMobile) {
        return (
            <React.Fragment>
                <div
                    style={{
                        width: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        textAlign: 'center',
                        marginTop: 35
                    }}
                >
                    <img
                        style={{
                            width: 170,
                            opacity: 0.8,
                            marginBottom: 50
                        }}
                        src={
                            appGlobal.appAssets.images.searchPageBackground
                                ? appGlobal.appAssets.images.searchPageBackground
                                : appGlobal.appAssets.images.errorIcon1
                        }
                    ></img>

                    <span
                        className={'ant-text-18'}
                        style={{
                            marginBottom: 100
                        }}
                    >
                        {AntLocalization.translateText({ vi: 'Vui lòng xem trên máy tính !', en: 'Please view on a computer !', fr: 'Veuillez consulter sur ordinateur !', es: '¡Véalo en un ordenador!', id: 'Silakan lihat di komputer !', ja: 'パソコンでご覧ください！', zh: '请在电脑上查看！', ko: 'PC에서 확인해 주세요!', hi: 'कृपया कंप्यूटर पर देखें !', ar: 'يرجى العرض على الحاسوب !' })}
                    </span>
                    <img
                        style={{
                            width: 100,
                            opacity: 0.8
                        }}
                        src={
                            appGlobal && appGlobal.appAssets && appGlobal.appAssets.images.logoWithBrandSlogun
                                ? appGlobal.appAssets.images.logoWithBrandSlogun
                                : undefined
                        }
                    ></img>
                </div>
            </React.Fragment>
        );
    }

    return (
        <GoogleOAuthProvider clientId="158493074087-lm8hmheup7hp8rmlrj54l0cbh8tgsosi.apps.googleusercontent.com">
            <AntGlobalContext.Provider value={appGlobal}>
                <div className={`ant-app ${loggedIn ? `mainArea` : `authArea`}`}>
                    {/* <div className={`ant-app ${screenSizeClass} ${loggedIn ? `mainArea` : `authArea`}`}> */}
                    {loggedIn && showMode === 'Web' ? (
                        <AntMainArea onLogOut={() => setLoggedIn(false)} />
                    ) : loggedIn && showMode === 'POS' ? (
                        <AntPOSArea />
                    ) : (
                        <AntAuthArea />
                    )}
                </div>
            </AntGlobalContext.Provider>
        </GoogleOAuthProvider>
    );
}
